import { __assign } from "tslib";
import React, { useEffect, useRef, useState } from 'react';
import HeaderNav from './components/HeaderNav';
import AddressInfo from './components/AddressInfo';
import s from './Header.module.css';
import logo from './assets/logo.svg';
import hamburgerIcon from './assets/hamburger.svg';
import cross from './assets/cross.svg';
import pocketIcon from './assets/pocket.svg';
import { Button } from '../Button';
import { ConnectWalletModal } from '../ConnectWalletModal/ConnectWalletModal';
import { MobileMenu } from './components/MobileMenu';
import { PrismicProvider } from '@prismicio/react';
import { client } from './prismic';
import { usePrismicData } from './usePrismicData';
import propTypes from 'prop-types';
import TailArrow from '../Icons/TailArrow';
import ArrowTop from '../Icons/ArrowTop';
import WalletConnectIcon from '../Icons/WalletConnectIcon';
import MetaMaskIcon from '../Icons/MetaMaskIcon';
function HeaderBody(_a) {
    var disconnect = _a.disconnect, account = _a.account, balance = _a.balance, loginMetamask = _a.loginMetamask, loginWalletConnect = _a.loginWalletConnect, _b = _a.connector, connector = _b === void 0 ? 'metamask' : _b;
    var _c = useState(''), address = _c[0], setAddress = _c[1];
    var _d = useState(false), isMobileNavOpen = _d[0], setIsMobileNavOpen = _d[1];
    var _e = useState(false), isAddressInfoOpen = _e[0], setIsAddressInfoOpen = _e[1];
    var _f = useState(false), isLoginModalOpen = _f[0], setIsLoginModalOpen = _f[1];
    var _g = useState(false), isFixed = _g[0], setIsFixed = _g[1];
    var headerRef = useRef(null);
    var data = usePrismicData();
    useEffect(function () {
        // @ts-ignore
        var headerOffsetTop = headerRef.current.offsetTop;
        var handleFixed = function () {
            if (window.scrollY >= headerOffsetTop - 20) {
                setIsFixed(true);
            }
            else {
                setIsFixed(false);
            }
        };
        handleFixed();
        window.addEventListener('scroll', handleFixed);
        return function () { return window.removeEventListener('scroll', handleFixed); };
    }, []);
    useEffect(function () {
        if (account) {
            setAddress(account);
            setIsLoginModalOpen(false);
        }
    }, [account]);
    useEffect(function () {
        if (window.innerWidth < 610) {
            var body = document.querySelector('body');
            if (body) {
                body.style.overflow = isMobileNavOpen ? 'hidden' : 'auto';
            }
        }
    }, [isMobileNavOpen]);
    var handleLogout = function () {
        disconnect();
        setAddress('');
        setIsAddressInfoOpen(false);
        setIsLoginModalOpen(false);
    };
    var handleLoginModal = function () { return setIsLoginModalOpen(function (state) { return !state; }); };
    var handleAddressInfo = function () { return setIsAddressInfoOpen(function (state) { return !state; }); };
    var handleMobileNav = function () { return setIsMobileNavOpen(function (state) { return !state; }); };
    return (React.createElement(React.Fragment, null,
        isLoginModalOpen && React.createElement("div", { className: s['blur-overlay'] }),
        React.createElement("header", { className: "".concat(s.header, " ").concat(isFixed ? s.header_fixed : ''), ref: headerRef },
            React.createElement("a", { href: "https://airdao.io/", className: s.header__logo },
                React.createElement("img", { src: logo, width: "160", height: "34", alt: "logo" })),
            React.createElement(HeaderNav, { className: s['nav-item-wrapper_desktop'], data: data.products }),
            address ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: s['header__buttons'] },
                    React.createElement("a", { href: data.amburl, className: s['header__button-tetiary'] },
                        React.createElement(Button, { type: "tetiary", size: "medium" },
                            React.createElement("span", null, "Get AMB"),
                            React.createElement(TailArrow, null)))),
                React.createElement("div", { className: s.header__address, onClick: handleAddressInfo },
                    connector === 'metamask' ? (React.createElement(MetaMaskIcon, null)) : (React.createElement(WalletConnectIcon, null)),
                    React.createElement("span", { className: s['header__address-text'] }, "".concat(address.substring(0, 5), "...").concat(address.substring(address.length - 5, address.length))),
                    React.createElement(ArrowTop, { className: "".concat(s['header__address-arrow'], " ").concat(isAddressInfoOpen ? '' : s['open']) })))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: s['header__buttons'] },
                    React.createElement("a", { href: data.amburl, className: s['header__button-tetiary'] },
                        React.createElement(Button, { type: "tetiary", size: "medium" },
                            React.createElement("span", null, "Get AMB"),
                            React.createElement(TailArrow, null))),
                    React.createElement(Button, { size: "medium", type: "secondary", onClick: handleLoginModal, className: s.connect_button },
                        React.createElement("img", { src: pocketIcon, height: "20", width: "20", alt: "connect wallet", className: s['connect-wallet-img'] }),
                        React.createElement("span", { className: s['connect-wallet-text'] }, "Connect wallet"))))),
            React.createElement("button", { onClick: handleMobileNav, className: s['hamburger-btn'] },
                React.createElement("img", { src: isMobileNavOpen ? cross : hamburgerIcon, width: "24", height: "24", alt: "menu" })),
            isAddressInfoOpen && (React.createElement(AddressInfo, { isOpen: isAddressInfoOpen, balance: balance, logout: handleLogout, address: address, close: handleAddressInfo })),
            isMobileNavOpen && (React.createElement(MobileMenu, { close: handleMobileNav, isOpen: isMobileNavOpen, data: data, balance: balance }))),
        isLoginModalOpen && (React.createElement(ConnectWalletModal, { isOpen: isLoginModalOpen, close: handleLoginModal, loginMetamask: loginMetamask, loginWalletConnect: loginWalletConnect }))));
}
export function Header(props) {
    return (React.createElement(PrismicProvider, { client: client },
        React.createElement(HeaderBody, __assign({}, props))));
}
Header.propTypes = {
    loginMetamask: propTypes.func.isRequired,
    loginWalletConnect: propTypes.func.isRequired,
    disconnect: propTypes.func.isRequired,
    account: propTypes.string.isRequired,
    balance: propTypes.string.isRequired,
};
//# sourceMappingURL=Header.js.map